// extracted by mini-css-extract-plugin
export default {"report":"styles_report__ASznL"};